module.exports = ".modal-backdrop {\n  z-index: -1; }\n\n/**************Modal*************/\n\n.modal-open {\n  overflow: hidden; }\n\n.modal {\n  position: fixed;\n  top: 55px;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/entity-edit-button/entityrecord-edit-button.component.scss
// module id = ./src/app/shared/components/widgets/entity-edit-button/entityrecord-edit-button.component.scss
// module chunks = main